import findNextEnabledIndex from './find-next-enabled-index';
import { DOWN_ARROW_KEY, LEFT_ARROW_KEY, RIGHT_ARROW_KEY, UP_ARROW_KEY } from '../../../../../const/keyNames';
export var isDisabled = function (index, ineligibleDays) {
    return ineligibleDays.includes(index + 1);
};
export var handleRight = function (_a) {
    var index = _a.index, col = _a.col, row = _a.row, numbersLength = _a.numbersLength, ineligibleDays = _a.ineligibleDays;
    if (col < row - 1) {
        var nextIndex_1 = findNextEnabledIndex('right', ineligibleDays, isDisabled, numbersLength, index + 1);
        if (nextIndex_1 !== -1 &&
            Math.floor(nextIndex_1 / row) === Math.floor(index / row)) {
            return nextIndex_1;
        }
    }
    var downRowIndex = index + row;
    var nextIndex = findNextEnabledIndex('right', ineligibleDays, isDisabled, numbersLength, downRowIndex - col);
    return nextIndex !== -1 && nextIndex < numbersLength ? nextIndex : index;
};
export var handleLeft = function (_a) {
    var index = _a.index, col = _a.col, row = _a.row, numbersLength = _a.numbersLength, ineligibleDays = _a.ineligibleDays;
    if (col > 0) {
        return findNextEnabledIndex('left', ineligibleDays, isDisabled, numbersLength, index - 1);
    }
    var upColumnIndex = index - row;
    return upColumnIndex >= 0
        ? findNextEnabledIndex('left', ineligibleDays, isDisabled, numbersLength, upColumnIndex + (row - 1))
        : index;
};
export var handleDown = function (_a) {
    var index = _a.index, row = _a.row, numbersLength = _a.numbersLength, ineligibleDays = _a.ineligibleDays;
    var downIndex = index + row;
    if (downIndex < numbersLength) {
        var nextIndex = findNextEnabledIndex('right', ineligibleDays, isDisabled, numbersLength, downIndex);
        if (isDisabled(nextIndex, ineligibleDays)) {
            return findNextEnabledIndex('left', ineligibleDays, isDisabled, numbersLength, downIndex);
        }
        return nextIndex;
    }
    return index;
};
export var handleUp = function (_a) {
    var index = _a.index, row = _a.row, numbersLength = _a.numbersLength, ineligibleDays = _a.ineligibleDays;
    var upIndex = index - row;
    if (upIndex >= 0) {
        var nextIndex = findNextEnabledIndex('left', ineligibleDays, isDisabled, numbersLength, upIndex);
        if (isDisabled(nextIndex, ineligibleDays)) {
            return findNextEnabledIndex('right', ineligibleDays, isDisabled, numbersLength, upIndex);
        }
        return nextIndex;
    }
    return index;
};
export var handleKeyDown = function (_a) {
    var _b;
    var _c, _d;
    var event = _a.event, index = _a.index, row = _a.row, numbersLength = _a.numbersLength, ineligibleDays = _a.ineligibleDays, setFocusedIndex = _a.setFocusedIndex;
    var col = index % row;
    var handlers = (_b = {},
        _b[RIGHT_ARROW_KEY] = function () {
            return handleRight({
                index: index,
                col: col,
                row: row,
                numbersLength: numbersLength,
                ineligibleDays: ineligibleDays
            });
        },
        _b[LEFT_ARROW_KEY] = function () {
            return handleLeft({
                index: index,
                col: col,
                row: row,
                numbersLength: numbersLength,
                ineligibleDays: ineligibleDays
            });
        },
        _b[DOWN_ARROW_KEY] = function () {
            return handleDown({
                index: index,
                col: col,
                row: row,
                numbersLength: numbersLength,
                ineligibleDays: ineligibleDays
            });
        },
        _b[UP_ARROW_KEY] = function () {
            return handleUp({
                index: index,
                col: col,
                row: row,
                numbersLength: numbersLength,
                ineligibleDays: ineligibleDays
            });
        },
        _b);
    var key = event.key;
    var nextIndex = (_d = (_c = handlers[key]) === null || _c === void 0 ? void 0 : _c.call(handlers)) !== null && _d !== void 0 ? _d : index;
    if (nextIndex !== index)
        setFocusedIndex(nextIndex);
};
